import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface HeroActionProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  primary?: boolean;
  danger?: boolean;
  disabled?: boolean;
}

export function HeroAction({
  icon: Icon,
  label,
  onClick,
  primary,
  danger,
  disabled,
}: HeroActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-flex items-center gap-2 h-9 px-4 rounded-full border transition-all active:scale-[0.97]",
        "text-[12px] font-bold backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed",
        primary
          ? "bg-white text-foreground border-white hover:bg-white/90"
          : danger
            ? "bg-red-500/20 text-white border-red-300/40 hover:bg-red-500/30"
            : "bg-white/10 text-white border-white/30 hover:bg-white/20",
      )}
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2} />
      <span>{label}</span>
    </button>
  );
}
